<template>
	<inertia-head title="Silver Call" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Gold Call</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Live and Replays of the Gold Call exclusive to Truly Rich Club
						Members.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div v-if="user.current_rank === 'SILVER'">
			<div class="alert alert-warning">
				<p class="mb-0 fw-semibold">
					UPGRADE to GOLD or HIGHER to view GOLD CALL
				</p>
			</div>
		</div>
		<div v-else>
			<div v-if="featured" class="block block-rounded">
				<div class="block-header border-bottom">
					<h3 class="block-title">{{ featured.title }}</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div class="col-md-8">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
									:src="`https://player.vimeo.com/video/${featured.video_id}`"
									style="
										position: absolute;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
									"
									frameborder="0"
									allow="autoplay; fullscreen; picture-in-picture"
									allowfullscreen
								></iframe>
							</div>
						</div>
						<div class="col-md-4">
							<div style="padding: 56.25% 0 0 0; position: relative">
								<iframe
									:src="`https://vimeo.com/live-chat/${featured.video_id}`"
									style="
										position: absolute;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
									"
									frameborder="0"
								></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="videos.length > 0" class="block block-rounded">
				<div class="block-header border-bottom">
					<h3 class="block-title">Gold Call Replays</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row g-sm">
						<div
							v-for="video in videos"
							:key="video.id"
							class="col-md-6 mb-4 m-auto"
						>
							<VimeoIframe :videoId="video.video_id" />
						</div>
					</div>
				</div>
			</div>
			<div v-else class="block">
				<div class="block-header border-bottom">
					<h3 class="block-title">Gold Call Replays</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row g-sm">
						NO VIDEO FOUND
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		user: Object,
		featured: Object,
		videos: Object,
	},
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
